<template>
  <div>
    <router-view class="app-route-placement"></router-view>

    <LoginModal />
    <Toaster />
    <HelpAndSupport :isShowModal="isShowHelpModal" />
  </div>
</template>
<script>
import HelpAndSupport from '@/components/HelpAndSupport.vue';
import LoginModal from './views/layouts/LoginModal.vue';
import Toaster from 'resonance-theme/src/vue/components/Toaster.vue';

export default {
  components: {
    HelpAndSupport,
    LoginModal,
    Toaster,
  },
  data() {
    return {
      isShowHelpModal: 0,
    };
  },
  mounted() {
    // load Umami script if not in local env
    const script = document.createElement("script");
    script.defer = true;
    script.src = process.env.VUE_APP_UMAMI_URL;
    script.setAttribute("data-website-id", process.env.VUE_APP_UMAMI_ID);
    script.onload = () => {
      if (window.umami) {
        const userEmail = this.$auth?.auth ?? null; // logged-in user email
        if (userEmail) {
          window.umami.identify({ email: userEmail }); // identify user for the session
        }
      }
    };
    document.head.appendChild(script);

    // handle the problem of navigating named anchors when routes don't change
    if (this.$route.hash) {
      setTimeout(() => this.scrollTo(this.$route.hash), 1);
    }

    // to show help & support modal
    this.$bus.on('show-support-form', () => {
      this.isShowHelpModal = Math.floor(Math.random() * Number.MAX_SAFE_INTEGER);
    });
  },
  methods: {
    scrollTo: function (hashtag) {
      setTimeout(() => {
        location.href = hashtag;
      }, 1);
    },
  },
};
</script>
